export default (theme) => ({
    button: {
        marginLeft: 170,
    },
});
